import { render, staticRenderFns } from "./FTXSwapUsdtMarketPrice.vue?vue&type=template&id=d0b48804&"
import script from "./FTXSwapUsdtMarketPrice.vue?vue&type=script&lang=js&"
export * from "./FTXSwapUsdtMarketPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports